/** @format */

import {CommonChartData} from 'components/charts/multiline-chart/model/charts';
import {TooltipExtraRow, TooltipValue} from 'components/charts/multiline-chart/model/tooltip';

import getTooltipPointForecast from '../../../mapping/tooltip/getTooltipPointForecast';

export function getFunnelTooltipValue(
  point: CommonChartData,
  prev?: CommonChartData,
): TooltipValue {
  if (point.primary !== undefined) {
    return {primary: String(point.primary)};
  }
  if (point.average !== undefined) {
    return {primary: String(point.average)};
  }
  if (point.range) {
    const avg = (point.range[0] + point.range[1]) / 2;
    return {primary: String(avg)};
  }
  return {primary: prev?.primary !== undefined ? String(prev.primary) : ''};
}

export function getFunnelForecastRows(
  point: CommonChartData,
  token: string | undefined,
  roundNumberBy: number,
  hideForecast: boolean,
  isForecastZone: boolean,
  pointName: string,
  prev?: CommonChartData,
): TooltipExtraRow[] {
  const direct = getTooltipPointForecast({
    data: point,
    token,
    roundNumberBy,
    hideForecast,
  });

  if (direct.length || !isForecastZone) return direct;

  const base = prev?.primary ?? 0;
  const fakePoint: CommonChartData = {
    name: pointName,
    average: base,
    range: [base, base],
  };

  return getTooltipPointForecast({
    data: fakePoint,
    token,
    roundNumberBy,
    hideForecast,
  });
}
